export default __webpack_public_path__ + "static/Medical_Brew-d9c3463dcf6c4cfc8ac321d509dd007d.png";